import * as React from "react";
import { NewModal } from "../uiMerge/newModal";
 
interface RedirectModalProps {
  referralCountdown: number,
  referralUrl: string,
  visible: boolean
}
 
export const RedirectModal: React.FC<RedirectModalProps> = (props) => {
  const { referralCountdown, referralUrl, visible } = props;
 
  return (
    <NewModal 
    isOpen={visible} 
    canClickOutsideToClose ={true} 
    colorClass="bg-[#1E1E1E]" 
    heightClass="h-[175px]" 
    roundedClass="rounded-2xl" 
    widthClass="w-[329px]" 
    showCloseButton={false} 
    animationClass="grow-in" 
    position="center" 
    onClose={()=> {}}>
      <div className=" flex py-5 gap-3 mt-7 justify-center items-center flex-col">
        <p className="text-2xl text-white font-bold">
          This is a referral offer!
        </p>
        
        <div>
          <p className="text-md text-center text-white">
            Redirecting in {referralCountdown} seconds...
          </p>
          <p className="text-md text-center text-white font-normal">
            If you are not redirected, <a href={referralUrl} className="text-[#C553FC] underline">click here</a>.
          </p>
        </div>
      </div>
    </NewModal>
  );
}